module.exports = __webpack_public_path__ + "static/puto-bigas-c9b727ca18c68970644ff0ec53e96d6f.jpg";